<div class="drawer-header mb-4">
  <h2 class="text-lg font-semibold capitalize">
    @if (customTitle) {
      {{ customTitle }}
    } @else {
      {{ actionTranslationKey | translate: { item: entityTranslationKey | translate } }}
      @if (shouldShowItemName) {
        {{ itemName }}
      }
    }
  </h2>
</div>
